// extracted by mini-css-extract-plugin
export var button = "address-add-module--button--b0923";
export var form = "address-add-module--form--071b7";
export var globalError = "address-add-module--global-error--2cfd5";
export var labelInput = "address-add-module--label-input--ac435";
export var noAddressesMessage = "address-add-module--no-addresses-message--e99c2";